import { render } from "./SaveSubscriber.vue?vue&type=template&id=9dc9767e&scoped=true"
import script from "./SaveSubscriber.vue?vue&type=script&lang=js"
export * from "./SaveSubscriber.vue?vue&type=script&lang=js"

import "./SaveSubscriber.vue?vue&type=style&index=0&id=9dc9767e&scoped=true&lang=css"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc9767e"]])

export default __exports__